import { Table } from "@mantine/core";
import { useHeldEmailActionable } from "../../../hooks/admin/useHeldEmailSelection";
import { HeldEmailListItem } from "../../../services/admin/systemEmails.service";
import { HeldEmailRowActionsMenu } from "./HeldEmailRowActionsMenu";

interface Props {
  model: {
    email: HeldEmailListItem;
    canRelease: boolean;
    onView: (id: string) => void;
    onRelease: (ids: string[]) => void;
    onCancel: (ids: string[]) => void;
  };
}

export function HeldEmailQueueActionsCell({ model }: Props) {
  const actionable = useHeldEmailActionable(model.email, model.canRelease);
  return (
    <Table.Td>
      <HeldEmailRowActionsMenu
        model={{
          actionable,
          heldEmailId: model.email.id,
          onCancel: model.onCancel,
          onRelease: model.onRelease,
          onView: model.onView,
        }}
      />
    </Table.Td>
  );
}
